import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut, getAuth } from 'firebase/auth';
import styles from './AppBar.module.css';
import { useTheme } from '../context/ThemeProvider';
import { useUser } from '../context/UserContext';

const AppBar: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const { user, role } = useUser();
  const isDarkMode = theme === 'dark';
  const navigate = useNavigate();

  const logoPath = isDarkMode
    ? "/assets/identity/logo-dark.svg"
    : "/assets/identity/logo.svg";

  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  const handleLogout = async () => {
    try {
      await signOut(getAuth());
      navigate('/login');
    } catch (err) {
      if (process.env.NODE_ENV !== 'production') {
        console.error('Logout error:', err);
      }
    }
  };

  return (
    <header className={`${styles.appBar} ${isDarkMode ? styles.dark : ''}`}>
      <div className={styles.container}>

        {/* logo */}
        <div className={styles.logo} onClick={() => navigate('/')}>
          <img src={logoPath} alt="Logo" className={styles.icon} width={107} height={24} />
          {role === 'internal_admin' && (
            <span className={styles.adminLabel}>ADMIN</span>
          )}
        </div>

        {/* Actions */}
        <div className={styles.actions}>

          {/* Light / dark mode */}
          <button
            className={styles.button}
            onClick={toggleTheme}
            aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {isDarkMode ? <img src="/assets/icons/sun.max.svg" alt="Light mode" width={24} height={24} /> : <img src="/assets/icons/moon.black.svg" alt="Dark mode" width={24} height={24} />}
          </button>

          {/* Logout / login buttons */}
          {user ? (
            <button
              className={styles.button}
              onClick={handleLogout}
              aria-label="Logout"
            >
              <img
                src={isDarkMode ? "/assets/icons/arrow.right.circle.svg" : "/assets/icons/arrow.right.circle.black.svg"}
                alt="Logout"
                width={24}
                height={24}
              />
            </button>
          ) : (
            <button
              className={styles.button}
              onClick={() => navigate('/login')}
              aria-label="Login"
            >
              <img
                src={isDarkMode ? "/assets/icons/person.svg" : "/assets/icons/person.black.svg"}
                alt="Login"
                width={24}
                height={24}
              />
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default AppBar;
